module.exports = __webpack_public_path__ + "static/img/shezhi_caijin.28cb246b.png";